const removeClasses = (ele, ...classes) => ele.classList.remove(...classes);

export default removeClasses;
